export const LandingNav = {
  tag: 'nav',
  flow: 'x',
  align: 'center space-between',
  padding: 'A C',
  position: 'fixed',
  top: '0',
  left: '0',
  right: '0',
  zIndex: '100',
  background: 'neutral950',
  borderBottom: 'none',
  transition: 'background 300ms',

  '@mobileL': { padding: 'A Z' },

  LogoLink: {
    extends: 'Link',
    href: '/',
    text: 'TrustLegal',
    fontSize: 'B',
    fontWeight: '800',
    color: 'green',
    textDecoration: 'none',
    flex: '1'
  },

  NavLinks: {
    flow: 'x',
    gap: 'B',
    align: 'center center',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    '@tabletS': { gap: 'A' },
    '@mobileL': { display: 'none' },
    NavLink1: {
      extends: 'Link',
      href: '/for-lawyers',
      text: 'For Lawyers',
      color: 'textSoft',
      fontSize: 'A',
      textDecoration: 'none',
      '@tabletS': { fontSize: 'Z' }
    },
    NavLink4: {
      extends: 'Link',
      href: '/for-clients',
      text: 'For Clients',
      color: 'textSoft',
      fontSize: 'A',
      textDecoration: 'none',
      '@tabletS': { fontSize: 'Z' }
    },
    NavLink5: {
      extends: 'Link',
      href: '/lawyers',
      text: '{{ lawyersNav | polyglot }}',
      color: 'green',
      fontSize: 'A',
      fontWeight: '600',
      textDecoration: 'none',
      '@tabletS': { fontSize: 'Z' }
    },
    NavLinkChat: {
      extends: 'Link',
      href: '/chat',
      text: 'AI Assistant',
      color: 'green',
      fontSize: 'A',
      fontWeight: '600',
      textDecoration: 'none',
      '@tabletS': { fontSize: 'Z' }
    }
  },

  NavActions: {
    flow: 'x',
    gap: 'A',
    align: 'center center',
    flex: '1',
    justifyContent: 'flex-end',
    '@mobileL': { gap: 'Y' },

    LangMenu: {
      position: 'relative',
      align: 'center center',

      LangBtn: {
        tag: 'button',
        align: 'center center',
        gap: 'Y',
        padding: 'Z A',
        borderRadius: 'Z',
        cursor: 'pointer',
        background: 'transparent',
        border: 'none',
        ':hover': { background: 'white .08' },
        onClick: (e, el, s) => {
          e.stopPropagation()
          s.root.update({ activeLangMenu: !s.root.activeLangMenu })
        },
        LangFlag: {
          fontSize: 'B',
          text: (el, s) => {
            const flags = { en: '\uD83C\uDDEC\uD83C\uDDE7', ka: '\uD83C\uDDEC\uD83C\uDDEA', ru: '\uD83C\uDDF7\uD83C\uDDFA', uk: '\uD83C\uDDFA\uD83C\uDDE6', tr: '\uD83C\uDDF9\uD83C\uDDF7', zh: '\uD83C\uDDE8\uD83C\uDDF3', hi: '\uD83C\uDDEE\uD83C\uDDF3', msa: '\uD83C\uDDF8\uD83C\uDDE6' }
            const lang = s.root?.lang || 'en'
            return flags[lang] || flags.en
          }
        },
        LangCode: {
          fontSize: 'A',
          fontWeight: '600',
          color: 'textSoft',
          '@mobileL': { display: 'none' },
          text: (el, s) => {
            const codes = { en: 'EN', ka: 'GE', ru: 'RU', uk: 'UA', tr: 'TR', zh: 'ZH', hi: 'HI', msa: 'MSA' }
            const lang = s.root?.lang || 'en'
            return codes[lang] || codes.en
          }
        }
      },

      LangDropdown: {
        flow: 'y',
        position: 'absolute',
        top: 'calc(100% + Z)',
        right: '0',
        background: 'neutral800',
        borderRadius: 'Z',
        boxShadow: 'black .2 0 Y Z, black .3 0 Z B',
        padding: 'X',
        minWidth: 'E',
        zIndex: '300',
        opacity: (el, s) => (s.root.activeLangMenu ? '1' : '0'),
        pointerEvents: (el, s) => (s.root.activeLangMenu ? 'auto' : 'none'),
        transition: 'opacity 0.15s ease, transform 0.15s ease',
        transform: (el, s) => s.root.activeLangMenu ? 'translateY(0)' : 'translateY(-6px)',

        LangEn: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'en' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDEC\uD83C\uDDE7', fontSize: 'A' },
          NameEl: { text: 'English', fontSize: 'Z', color: 'text', fontWeight: '500' }
        },
        LangKa: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'ka' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDEC\uD83C\uDDEA', fontSize: 'A' },
          NameEl: { text: '\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8', fontSize: 'Z', color: 'text', fontWeight: '500' }
        },
        LangRu: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'ru' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDF7\uD83C\uDDFA', fontSize: 'A' },
          NameEl: { text: '\u0420\u0443\u0441\u0441\u043A\u0438\u0439', fontSize: 'Z', color: 'text', fontWeight: '500' }
        },
        LangUk: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'uk' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDFA\uD83C\uDDE6', fontSize: 'A' },
          NameEl: { text: '\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430', fontSize: 'Z', color: 'text', fontWeight: '500' }
        },
        LangTr: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'tr' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDF9\uD83C\uDDF7', fontSize: 'A' },
          NameEl: { text: 'T\u00FCrk\u00E7e', fontSize: 'Z', color: 'text', fontWeight: '500' }
        },
        LangZh: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'zh' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDE8\uD83C\uDDF3', fontSize: 'A' },
          NameEl: { text: '\u4E2D\u6587', fontSize: 'Z', color: 'text', fontWeight: '500' }
        },
        LangHi: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'hi' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDEE\uD83C\uDDF3', fontSize: 'A' },
          NameEl: { text: '\u0939\u093F\u0928\u094D\u0926\u0940', fontSize: 'Z', color: 'text', fontWeight: '500' }
        },
        LangMsa: {
          align: 'center flex-start',
          gap: 'X',
          padding: 'X Z',
          borderRadius: 'Y',
          cursor: 'pointer',
          props: { langCode: 'msa' },
          ':hover': { background: 'white .08' },
          onClick: (e, el, s) => {
            e.stopPropagation()
            s.root.update({ lang: el.props.langCode, activeLangMenu: false })
            try { localStorage.setItem('legal_lang', el.props.langCode) } catch (e) {}
          },
          FlagEl: { text: '\uD83C\uDDF8\uD83C\uDDE6', fontSize: 'A' },
          NameEl: { text: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629', fontSize: 'Z', color: 'text', fontWeight: '500' }
        }
      }
    },

    LoginLink: {
      extends: 'Link',
      href: '/login',
      text: '{{ login | polyglot }}',
      theme: 'ghost',
      padding: 'Z B',
      fontSize: 'A',
      borderRadius: 'Z',
      textDecoration: 'none',
      '@mobileL': { display: 'none' }
    },
    CtaLink: {
      extends: 'Link',
      href: '/dashboard',
      text: '{{ getStarted | polyglot }}',
      background: 'green',
      color: 'neutral950',
      padding: 'Z B',
      fontSize: 'A',
      fontWeight: '600',
      borderRadius: 'D',
      textDecoration: 'none',
      transition: 'transform 200ms',
      ':hover': { transform: 'scale(0.98)' },
      onClick: (e, el, s) => s.root.update({ loggedIn: true }),
      '@mobileL': { padding: 'Z A', fontSize: 'Z' }
    }
  }
}
